import React from 'react';
import { Link } from 'react-router-dom';
import MarketingLayout from '../components/MarketingLayout';

const values = [
    ['Fast for customers', 'Guests should scan, choose, and order without confusion.'],
    ['Clear for staff', 'Kitchen and counter teams need simple tickets, not complicated screens.'],
    ['Useful for owners', 'Plans, analytics, offers, and exports help restaurants make better decisions.'],
];

export default function AboutPage() {
    return (
        <MarketingLayout>
            <main>
                <section className="mx-auto grid max-w-7xl gap-8 px-4 py-16 lg:grid-cols-[1fr_0.9fr] lg:px-8">
                    <div>
                        <p className="section-title">About GetYourQR</p>
                        <h1 className="mt-3 text-5xl font-black tracking-tight">A QR ordering system made for real table service</h1>
                        <p className="mt-5 text-sm font-medium leading-7 text-slate-500">
                            GetYourQR brings menu management, QR code generation, cart checkout, live orders, offers, analytics, and receipts into one restaurant dashboard.
                        </p>
                        <Link to="/login" className="btn-primary mt-8 inline-flex">Create your restaurant</Link>
                    </div>
                    <img src="https://images.unsplash.com/photo-1514933651103-005eec06c04b?w=1200&q=80" alt="Decorative graphic" className="h-96 w-full object-cover shadow-sm" />
                </section>

                <section className="bg-white py-16">
                    <div className="mx-auto max-w-7xl px-4 lg:px-8">
                        <h2 className="text-3xl font-black tracking-tight">What the product focuses on</h2>
                        <div className="mt-6 grid gap-4 md:grid-cols-3">
                            {values.map(([title, text]) => (
                                <article key={title} className="card">
                                    <h3 className="text-lg font-black">{title}</h3>
                                    <p className="mt-2 text-sm font-medium leading-6 text-slate-500">{text}</p>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>
            </main>
        </MarketingLayout>
    );
}
